import { Button, IconButton } from '@mui/material'
import React from 'react'
import { Circle, Group } from 'react-konva'
import { Html } from 'react-konva-utils'
import {v4} from 'uuid'
import CircleIcon from '@mui/icons-material/Circle';

function randomNumber(min, max) { 
    return Math.floor(Math.random() * (max - min) + min);
} 

const AgregarNodo = (props) => {

    const {
        id,
        x,
        y,
        width,
        height,
        radius,
        fill,
        setNodos,
        nodos,
        lineas,
        setLineas,
        historial,
        setHistorial,
        historyStep,
        setHistoryStep,
    } = props
    

    const createNodeDerecha = (e) =>{
        
        const newNodo = {
            id: 'Nodo-'+v4(),
            text: 'Doble Click para editar ',
            x: x+width+100,
            y: y+height/2-25+randomNumber(-width, width),
            isDragging: false,
            width: 200,
            height: 50,
            fontSize: 20,
            align: 'center',
            fontStyle:'normal',
            verticalAlign: 'middle',
            textFill: '#000000',
            fill:'#13B6F1',
            contorno:'#13B6F1',
            strokeWidth:1,
            urlImagen: '',
            tieneImagen: false,
            imgWidth: 200,
            imgHeight: 50,
        }
        const newLine = {
            id: 'Line-'+v4(),
            vertices: [
                x+width/2, 
                y+height/2, 
                newNodo.x+newNodo.width/2, 
                newNodo.y+newNodo.height/2
            ],
            isDragging: false,
            rectangulosLinea: [id, newNodo.id],
        }
        setLineas([...lineas, newLine]);
        setNodos([...nodos, newNodo]);

        setHistorial([...historial,nodos])
        setHistoryStep(historyStep+1);
    }

    const createNodeIzq = (e) =>{

        const newNodo = {
            id: 'Nodo-'+v4(),
            text: 'Doble Click para editar ',
            x: x-300,
            y: y+height/2-25+randomNumber(-width, width),
            isDragging: false,
            width: 200,
            height: 50,
            fontSize: 20,
            align: 'center',
            fontStyle:'normal',
            verticalAlign: 'middle',
            textFill: '#000000',
            fill:'#CD7DD6',
            contorno:'#CD7DD6',
            strokeWidth:1,
            urlImagen: '',
            tieneImagen: false,
            imgWidth: 200,
            imgHeight: 50,
        }
        const newLine = {
            id: 'Line-'+v4(),
            vertices: [
                x+width/2, 
                y+height/2, 
                newNodo.x+newNodo.width/2, 
                newNodo.y+newNodo.height/2
            ],
            isDragging: false,
            rectangulosLinea: [id, newNodo.id],
        }
        setLineas([...lineas, newLine]);
        setNodos([...nodos, newNodo]);
        
        setHistorial([...historial,nodos])
        setHistoryStep(historyStep+1);
    }
 
    const createNodeUp = (e) =>{

        const newNodo = {
            id: 'Nodo-'+v4(),
            text: 'Doble Click para editar ',
            x: x+width/2-100+randomNumber(-width, width),
            y: y-150,
            isDragging: false,
            width: 200,
            height: 50,
            fontSize: 20,
            align: 'center',
            fontStyle:'normal',
            verticalAlign: 'middle',
            textFill: '#000000',
            fill:'#E1E160',
            contorno:'#E1E160',
            strokeWidth:1,
            urlImagen: '',
            tieneImagen: false,
            imgWidth: 200,
            imgHeight: 50,
        }
        const newLine = {
            id: 'Line-'+v4(),
            vertices: [
                x+width/2, 
                y+height/2, 
                newNodo.x+newNodo.width/2, 
                newNodo.y+newNodo.height/2
            ],
            isDragging: false,
            rectangulosLinea: [id, newNodo.id],
        }
        setLineas([...lineas, newLine]);
        setNodos([...nodos, newNodo]);

    }

    const createNodeDown = (e) =>{

        const newNodo = {
            id: 'Nodo-'+v4(),
            text: 'Doble Click para editar ',
            x: x+width/2-100+randomNumber(-width, width),
            y: y+height+100,
            isDragging: false, 
            width: 200,
            height: 50,
            fontSize: 20,
            align: 'center',
            fontStyle:'normal',
            verticalAlign: 'middle',
            textFill: '#000000',
            fill:'#E19360',
            contorno:'#E19360',
            strokeWidth:1,
            urlImagen: '',
            tieneImagen: false,
            imgWidth: 200,
            imgHeight: 50,
        }
        const newLine = {
            id: 'Line-'+v4(),
            vertices: [
                x+width/2, 
                y+height/2, 
                newNodo.x+newNodo.width/2, 
                newNodo.y+newNodo.height/2
            ],
            isDragging: false,
            rectangulosLinea: [id, newNodo.id],
        }
        setLineas([...lineas, newLine]);
        setNodos([...nodos, newNodo]);
        
        setHistorial([...historial,nodos])
        setHistoryStep(historyStep+1);
    }

    return (
        <>
            <Group
                x={x+width} 
                y={y+height/2-17} 
            >
                <Html divProps={{ style: { opacity: 1 } }}>
                    <IconButton
                        onClick={createNodeDerecha}
                        size='small'
                    >
                        <CircleIcon
                            color="black"
                            size='small'
                            style={{
                                color: 'black'
                            }}
                        />
                    </IconButton>
                </Html>
            </Group>

            {/* <Circle 
                x={x+width+20} 
                y={y+height/2} 
                radius={10} 
                fill="black" 
                
                onClick={createNodeDerecha}
                onTap={createNodeDerecha}
                
            /> */}
            
            {/* <Circle 
                x={x-20} 
                y={y+height/2} 
                radius={10} 
                fill="black" 
                onClick={createNodeIzq}
                onTap={createNodeIzq}
            /> */}

            <Group
                /* x={x+width} 
                y={y+height/2-17}  */
                x={x-34} 
                y={y+height/2-17} 
            >
                <Html divProps={{ style: { opacity: 1 } }}>
                    <IconButton
                        onClick={createNodeIzq}
                        size='small'
                    >
                        <CircleIcon
                            color="black"
                            size='small'
                            style={{
                                color: 'black'
                            }}
                        />
                    </IconButton>
                </Html>
            </Group>

            <Group
                x={x+width/2-17} 
                y={y-34} 
            >
                <Html divProps={{ style: { opacity: 1 } }}>
                    <IconButton
                        onClick={createNodeUp}
                        size='small'
                    >
                        <CircleIcon
                            color="black"
                            size='small'
                            style={{
                                color: 'black'
                            }}
                        />
                    </IconButton>
                </Html>
            </Group>

            {/* <Circle 
                x={x+width/2} 
                y={y-20} 
                radius={10} 
                fill="black" 
                onClick={createNodeUp}
                onTap={createNodeUp}
            /> */}
            <Group
                /* x={x+width/2-17} 
                y={y-34}  */
                x={x+width/2-17}  
                y={y+height} 
            >
                <Html divProps={{ style: { opacity: 1 } }}>
                    <IconButton
                        onClick={createNodeDown}
                        size='small'
                    >
                        <CircleIcon
                            color="black"
                            size='small'
                            style={{
                                color: 'black'
                            }}
                        />
                    </IconButton>
                </Html>
            </Group>
            {/* <Circle 
                x={x+width/2} 
                y={y+height+20} 
                radius={10} 
                fill="black"  
                onClick={createNodeDown}
                onTap={createNodeDown}
            /> */}
            
        </>
    )
}

export default AgregarNodo;
